<div class="TotemScreenSaver bg-dark {{ fadeDirection != null ? 'pg-animation-fade' + fadeDirection : '' }}" role="dialog" aria-modal="true" [attr.aria-label]="'totem-a11y.screensaver-start' | locTranslate">
    @if (playData.video != null) {
        <video #playVideo class="TotemScreenSaver-Video" aria-hidden="true">
            <source src="{{playData.video}}" type="video/mp4"/>
        </video>
    }
    @if (playData.slides != null) {
        <div class="TotemScreenSaver-Slides" aria-live="polite">
            @for (slide of playData.slides; track slide; let i = $index) {
                <div class="TotemScreenSaver-Slides-Item {{i == slideIndex ? '' : 'opacity-00'}}" [attr.aria-hidden]="i != slideIndex">
                    <img class="TotemScreenSaver-Slides-Item-Image" [src]="slide.image" [alt]="slide.text | locTranslate"/>
                    <div class="TotemScreenSaver-Slides-Item-Text text-light">{{slide.text | locTranslate}}</div>
                </div>
            }
        </div>
    }
    <div class="TotemScreenSaver-Action {{isChangingLanguage ? 'TotemScreenSaver-Action--ChangingLanguage' : ''}}">
        <button type="button" class="TotemScreenSaver-Action-Button" (click)="onDismiss($event)">
            {{availableLanguages[languageIndex].label}}
            <span class="visually-hidden"> — {{ 'totem-a11y.screensaver-start' | locTranslate }}</span>
        </button>
    </div>
</div>
